<template>
  <!--商户管理-->
  <div>
    <!--商户列表    -->
    <x-tabula
        ref="table"
        rowKey="leaderId"
        :dataSource="dataSource"
        :searchList="searchList"
        :columns="columns"
        :tableOptList="tableOptList"
        :rowOptList="rowOptList"
        :searchParams.sync="searchParams"
        :listApi="listApi"
        :addHandleParam="addHandleParam"
        :deleteParam="deleteParam"
        :rowSelection="false"
    >
      <template slot="opt_status" slot-scope="{row}">
        <div style="display: flex; align-items: center">
          <span class="circle-dot" :class="statusColor[row.status] + '-bg'"></span>
          <span>{{ statusObj[row.status] }}</span>
        </div>
      </template>
      <template slot="opt_type" slot-scope="{row}">
        {{ getTypeDesc(row.type) }}
      </template>
    </x-tabula>

    <!--请选择搜索数据同步类型的弹窗-->
    <a-modal
      title="请选择搜索数据同步类型"
      :visible="SDSVisible"
      @ok="SDSConfirm"
      @cancel="SDSVisible=false"
      :confirmLoading="btnLoading.loading"
      okText="确认"
      cancelText="取消"
      destroyOnClose
      centered
      :maskClosable="false"
      :keyboard="false"
    >
      <a-form :form="SDSForm" ref='SDS'>
        <a-form-item v-bind="$store.state.modal_ItemLayout" label="同步类型">
          <a-select
            v-decorator="['type', { rules: [{ required: true, message: '请选择搜索数据同步类型' }] }]"
            placeholder="请选择搜索数据同步类型">
            <a-select-option
              v-for="(item, index) of SDSType"
              :key="index"
              :value="item.value"
              :disabled="item.disabled">{{item.label}}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>

    <!--选择商家弹窗-->
    <a-modal
        title="选择同步商家"
        :visible="CMVisible"
        @cancel="CMVisible=false"
        @ok="CMVConfirm"
        :confirmLoading="btnLoading.loading"
        v-bind="$store.state.modalConfig"
        width="1000px"
    >
      <choose-merchant ref='chooseMerchant'></choose-merchant>
    </a-modal>

    <!--新增的弹窗-->
    <a-modal
        :title="modalTitle"
        :visible="visible"
        @cancel="visible=false"
        @ok="$refs.addEdit.handleSubmit()"
        :confirmLoading="btnLoading.loading"
        v-bind="$store.state.modalConfig"
        width="700px"
    >
      <x-addEdit
          ref="addEdit"
          formType="modal"
          :isSubmitBtn="false"
          :itemLayout="$store.state.modal_ItemLayout"
          :reqLoading="btnLoading"
          :formList="formList"
          :formKey="formKey"
          :addParam="addParam"
          :editParam="editParam"
          :detailParam="detailParam"
      >
        <template slot="1" slot-scope="{formItem}">
          <a-form-item v-if="formItem.show" :label="formItem.label" required v-bind="$store.state.modal_ItemLayout">
            <a-input v-decorator="formItem.props" :placeholder="formItem.placeholder"/>
          </a-form-item>
        </template>
      </x-addEdit>
    </a-modal>
    <!--    新增商户弹窗-->
    <a-modal
        :title="modalLeaderTitle"
        :visible="leaderVisible"
        @cancel="leaderVisible=false"
        @ok="addLeader"
        :confirmLoading="btnLoading.loading"
        v-bind="$store.state.modalConfig"
        width="700px"
    >
      <x-addEdit
          ref="addLeaderEdit"
          formType="modal"
          :isSubmitBtn="false"
          :itemLayout="$store.state.modal_ItemLayout"
          :reqLoading="btnLoading"
          :formList="formLeaderList"
          :formKey="formKey"
          :addParam="addParam"
          :editParam="editParam"
          :detailParam="detailParam"
      >
        <template slot="gps" slot-scope="{formItem}">

          <x-location
              ref="location"
              :form="$children[0].form"
              :inputKey="inputKey"
              :position="position"
              :lngLat="lngLat"
              :locationData="formItem"
              @transferValue="transferValue"
              itemLayout={}
              >
          </x-location>
        </template>
      </x-addEdit>
    </a-modal>
  </div>
</template>

<script>
import {fetchSelect} from '@/utils/mixins';
import Common from '@/utils/common';
import {handleHttpMethod} from 'ant-design-vue-admin-x';
import chooseMerchant from './chooseMerchant.vue';

export default {
  name: 'leader',
  components: {
    chooseMerchant
  },
  mixins: [fetchSelect],
  data () {
    return {
      CMVisible: false,
      SDSVisible: false,
      SDSType: [
        { label: '全量同步', value: '1' },
        { label: '选择同步', value: '2' }
      ],
      newAreas: undefined,
      singleOption: [],
      areaIndex: 1,
      regionUrl: {
        JAVA: '/regions/treeselect',
        PHP: '/get_area_tree'
      },
      modalLeaderTitle: '',
      leaderVisible: false,
      inputKey: {
        lng: 'mapLng',
        lat: 'mapLat',
        address: 'address'
      },
      upLoading: {loading: false},
      lngLat: [],
      position: '',
      modalTitle: '添加',
      visible: false,
      btnLoading: {loading: false},
      formList: [
        {
          label: '类型',
          inputType: 'select',
          options: [],
          placeholder: '请选择',
          handle: this.dataTypeChange,
          disabled: false,
          props: ['type', {
            rules: [{required: true, message: '请选择类型'}]
          }]
        },
        {
          label: '手机号',
          inputType: 'input',
          options: [],
          placeholder: '请输入手机号',
          disabled: false,
          props: ['mobilePhone', {
            rules: [
              {required: true, message: '请输入手机号'}
            ]
          }]
        },
        {
          slot: '1',
          show: false,
          label: '开户行',
          inputType: 'input',
          placeholder: '请输入开户行支行名称',
          props: ['depositBank', {
            rules: [{required: true, message: '请输入开户行支行名称'}]
          }]
        },
        {
          slot: '1',
          show: false,
          label: '银行账号',
          inputType: 'input',
          placeholder: '请输入银行账号',
          props: ['cardNumber', {
            rules: [{required: true, message: '请输入银行账号'}]
          }]
        },
        {
          slot: '1',
          show: false,
          label: '账户名称',
          inputType: 'input',
          placeholder: '请输入账户名称',
          props: ['accountName', {
            rules: [{required: true, message: '请输入账户名称'}]
          }]
        }
      ],
      areaLevel: '1,2,3,4',
      formLeaderList: [
        {
          label: '手机号',
          inputType: 'input',
          options: [],
          placeholder: '请输入手机号',
          props: ['mobilePhone', {
            rules: [
              {required: true, message: '请输入手机号'}
            ]
          }]
        },
        {
          label: '店铺名称',
          inputType: 'input',
          options: [],
          placeholder: '请输入店铺名称',
          props: ['shopName', {
            rules: [
              {required: true, message: '请输入店铺名称'}
            ]
          }]
        },
        {
          label: '主营类目',
          inputType: 'cascader',
          options: [],
          placeholder: '请选择主营类目',
          changeOnSelect: false,
          disabled: false,
          fieldNames: {label: 'label', value: 'value', children: 'children'},
          props: ['categories', {
            rules: [
              {required: true, message: '请选择主营类目'}
            ]
          }]
        },
        {
          label: '所在地区',
          inputType: 'cascader',
          options: [],
          placeholder: '请选择所在地区',
          handle: this.regionChange,
          displayRender: this.regionDisplayRender,
          expandTrigger: 'click',
          loadData: e => {
            this.newRegionSelect(3, 'formLeaderList', this.areaLevel, e);
          },
          props: ['areas', {
            rules: [
              {required: true, message: '请选择所在地区'}
            ]
          }]
        },
        // {
        //   slot: 'gps',
        //   label: '地图选址',
        //   inputType: 'input',
        //   subList: [
        //     {
        //       inputType: 'input',
        //       placeholder: '经度',
        //       props: ['mapLng', {
        //         validateTrigger: 'blur',
        //         rules: [{required: true, message: '请定位经度'}]
        //       }]
        //     },
        //     {
        //       inputType: 'input',
        //       placeholder: '纬度',
        //       props: ['mapLat', {
        //         validateTrigger: 'blur',
        //         rules: [{required: true, message: '请定位纬度'}]
        //       }]
        //     }
        //   ]
        // },
        // {
        //   label: '经度',
        //   inputType: 'input',
        //   options: [],
        //   placeholder: '请定位经度',
        //   props: ['mapLng', {
        //     rules: [
        //       {required: true, message: '请定位经度'}
        //     ]
        //   }]
        // },
        // {
        //   label: '纬度',
        //   inputType: 'input',
        //   options: [],
        //   placeholder: '请定位纬度',
        //   props: ['mapLat', {
        //     rules: [
        //       {required: true, message: '请定位纬度'}
        //     ]
        //   }]
        // },
        {
          label: '所属商圈',
          inputType: 'select',
          options: [],
          placeholder: '请选择所属商圈',
          // isShow: false,
          props: ['bizAreaId']
        },
        {
          slot: 'gps',
          label: 'GPS定位',
          inputType: 'input',
          subList: [
            {
              inputType: 'input',
              placeholder: '经度',
              props: ['mapLng', {
                rules: [
                  {required: true, message: '请定位经度'}
                ]
              }]
            },
            {
              inputType: 'input',
              placeholder: '纬度',
              props: ['mapLat', {
                rules: [
                  {required: true, message: '请定位纬度'}
                ]
              }]
            }
          ]
        },
        {
          label: '详细地址',
          inputType: 'input',
          options: [],
          placeholder: '请输入详细地址',
          props: ['address', {
            rules: [
              {required: true, message: '请输入详细地址'}
            ]
          }]
        },
        {
          label: '店铺门面',
          inputType: 'upload',
          options: [],
          handle: '',
          placeholder: '',
          extra: '图片大小不超过5MB，最多添加5张，用于店铺展示',
          fileList: [],
          beforeHandle: this.beforeUpload,
          uploadParam: {
            url: '/local/upload',
            iconUrl: 'pic',
            limit: 5,
            listType: 'picture',
            accept: this.$store.state.imgAccept,
            uploadType: 1
          },
          props: ['shopImage', {
            rules: [{required: true, message: '请上传店铺门面'}]
          }]
        },
        {
          label: '营业电话',
          inputType: 'input',
          options: [],
          placeholder: '请输入营业电话',
          props: ['telephone', {
            rules: [
              {required: true, message: '请输入营业电话'}
            ]
          }]
        },
        {
          label: '开户行',
          inputType: 'input',
          placeholder: '请输入开户行支行名称',
          props: ['depositBank', {
            rules: [{required: true, message: '请输入开户行支行名称'}]
          }]
        },
        {
          label: '银行账号',
          inputType: 'input',
          placeholder: '请输入银行账号',
          props: ['cardNumber', {
            rules: [{required: true, message: '请输入银行账号'}]
          }]
        },
        {
          label: '账户名称',
          inputType: 'input',
          placeholder: '请输入账户名称',
          props: ['accountName', {
            rules: [{required: true, message: '请输入账户名称'}]
          }]
        }
      ],
      formKey: {
        type: undefined,
        mapLng: undefined,
        mapLat: undefined,
        mobilePhone: undefined,
        shopImage: undefined,
        shopName: undefined,
        categories: undefined,
        areas: undefined,
        address: undefined,
        bizAreaId: undefined,
        telephone: undefined,
        depositBank: undefined,
        cardNumber: undefined,
        accountName: undefined,
        shopName: undefined
      },
      addParam: {
        url: '/local/leader/add',
        reqHandle: this.reqHandle,
        resHandle: () => this.addEditResHandle('新增')
      },
      editParam: {
        url: '/local/leader/',
        reqHandle: () => this.editReqHandle(), // this.addReqHandle
        resHandle: () => this.addEditResHandle('编辑')
      },
      detailParam: {
        url: '',
        resHandle: '' // this.detailResHandle
      },

      searchList: [
        {props: ['mobilePhone'], placeholder: '手机号', inputType: 'input'},
        {props: ['type'], placeholder: '类型', options: [], inputType: 'select'}
      ],
      // searchDataSynchronization
      tableOptList: [
        {text: '新增', icon: 'plus', handle: this.openModal, permi: ['community:localLeader:add']},
        {text: '新增商户', icon: 'plus', handle: this.openLeaderModal, permi: ['community:localLeader:add']},
        {text: '搜索数据同步', icon: 'retweet', handle: this.openSDSModal, permi: ['community:localLeader:searchDataSynchronization']}
      ],
      rowOptList: [
        {text: '编辑', rowOptDisHandle: row => { return row.canEdit == 0; }, handle: (row) => this.editHandle(row), permi: ['community:localLeader:edit']},
        {
          text: '',
          handle: row => this.changeStatus(row),
          customRender: true,
          rowOptText: row => row.status === 1 ? '停用' : '启用',
          permi: ['community:localLeader:status']
        }
      ],
      columns: [
        {title: '昵称', dataIndex: 'nickName', align: '', width: ''},
        {title: '手机号', dataIndex: 'mobilePhone', align: '', width: ''},
        {title: '店铺名称', dataIndex: 'shopName', align: '', width: ''},
        {title: '账号类型', dataIndex: 'type', align: '', width: '', scopedSlots: {customRender: 'type'}},
        {title: '状态', dataIndex: 'status', align: '', width: '', scopedSlots: {customRender: 'status'}},
        {title: '操作', dataIndex: 'action', align: '', width: '200px', scopedSlots: {customRender: 'action'}}
      ],
      statusObj: ['停用', '启用'], // 账号状态:0停用, 1启用
      statusColor: ['info', 'success'],
      dataSource: [],
      searchParams: {
        mobilePhone: undefined,
        type: undefined
      },
      listApi: {
        url: '/local/leader/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: 'leaderAdd',
        addTitle: '新增',
        editTitle: '编辑'
      },
      deleteParam: {
        url: '',
        title: '',
        key: '',
        resHandle: '' // 执行完删除的回调方法
      },
      selectedArera: undefined
    };
  },
  beforeCreate () {
    this.SDSForm = this.$form.createForm(this);
  },
  created () {
    this.newRegionSelect(3, 'formLeaderList');
    this.getSelect();
  },
  methods: {
    beforeUpload (file, fileList, item) {
      if (file.name.length > 100) {
        message.error('文件名长度不大于100');
        return false;
      }
      if (!file.type.includes('image')) {
        message.error('请上传图片');
        return false;
      }
      const isLt5M = Number(file.size) / (1024 * 1024) < 5;
      if (!isLt5M) {
        this.$message.error('图片最大为5M!');
      }
      return isLt5M;
    },
    /* 搜索数据同步 选择商家弹窗 */
    CMVConfirm () {
      let id = this.$refs.chooseMerchant.getSelectId();
      if (id.length > 0) {
        let obj = {
          type: 2,
          shopIds: id
        };
        this.submitRestart(obj);
      } else {
        this.$message.error('请选择同步商家');
      }
    },
    /* 搜索数据同步弹窗 */
    SDSConfirm () {
      this.SDSForm.validateFields((err, values) => {
        if (err) { return; }
        if (values.type == 1) {
          this.submitRestart(values);
        } else {
          this.CMVisible = true;
        }
      });
    },
    /** 提交搜索数据同步 */
    submitRestart (values) {
      this.$post({
        url: '/local/shop/syncSearchData',
        params: {...values},
        btnLoading: this.btnLoading
      }).then((res) => {
        if (res.code == 200) {
          this.SDSVisible = false;
          this.CMVisible = false;
          this.$message.success('操作成功');
        } else {
          this.SDSVisible = false;
          this.CMVisible = false;
        }
      });
    },
    transferValue (val) {
      this.$refs.addLeaderEdit.form.setFieldsValue(val);
    },
    /** 获取类型下拉 */
    getSelect () {
      this.$get({
        url: '/dict/data/dictType/comu_activity_leader_type',
        params: {}
      }).then(({data}) => {
        // this.formList[0].options = data;
        this.formList[0].options = [
          {label: '团长', value: '1'},
          {label: '推广', value: '2'}
        ];
        this.searchList[1].options = data;
      });

      // 主营类目下拉
      this.$get({
        url: '/local/leader/categoryTreeSelect'
      }).then(({data}) => {
        this.formLeaderList[2].options = data;
      });
    },
    recursionList (list) {
      list.forEach(item => {
        item.title = item.label;
        if (item.children && item.children.length) {
          this.recursionList(item.children);
        }
      });
    },
    /** 根据团长类型切换输入框 */
    dataTypeChange (val) {
      this.formList.forEach((el) => {
        el.slot === val ? el.show = true : el.show = false;
      });
    },
    /* 切换状态 */
    changeStatus (row) {
      let status = row.status === 1 ? 0 : 1;
      this.$put({
        url: `/local/leader/changeStatus/${row.leaderId}`,
        params: {
          status: status,
          type: row.type
        }
      }).then(({data}) => {
        this.$message.success('状态切换成功！');
        this.$refs.table.getTableList();
      });
    },
    openSDSModal () {
      this.SDSVisible = true;
    },
    /** 新增团长 */
    openModal () {
      this.modalTitle = '添加';
      this.visible = true;
      let mobileRules = this.formList[1].props[1].rules;
      mobileRules.splice(1, 1);
      (mobileRules.push({pattern: this.REG.mobile, message: this.MESSAGE.mobile}));
      this.formList.forEach((el) => {
        if (el.disabled) {
          el.disabled = false;
        }
      });
      this.dataTypeChange();
    },
    openLeaderModal () {
      // this.$router.push({
      //   name: 'leaderAdd'
      // });
      this.modalLeaderTitle = '添加';
      this.leaderVisible = true;
      let mobileRules = this.formLeaderList[0].props[1].rules;
      this.formLeaderList[7].fileList = [];
      mobileRules.splice(1, 1);
      (mobileRules.push({pattern: this.REG.mobile, message: this.MESSAGE.mobile}));
      this.formLeaderList.forEach((el) => {
        if (el.disabled) {
          el.disabled = false;
        }
      });
    },

    regionDisplayRender (labels) {
      this.regionChange(undefined, labels);
    },

    regionChange (val, selected) {
      let isArray = Array.isArray(val);
      if (isArray) { // 判断是change事件还是 displayRender
        this.$refs.location && this.$refs.location.positionChanged();
      }
      if (val && selected && selected.length > 0) {
        let temp = [];
        selected.forEach(item => {
          let i = item.level - 1;
          temp[i] = item.value;
        });
        for (let i = 0; i < 4; i++) {
          if (temp[i] == undefined) {
            temp[i] = 0;
          }
        }
        this.newAreas = temp.toString();
      }
      if (selected && selected.length > 1) {
        console.log('选择了省市区', val, selected);
        let isCity = this.$store.state.citys.some(el => {
          return el === (isArray ? selected[0].label : selected[0]);
        });
        if (isCity) { // 判断是否为直辖市
          this.position = isArray ? selected[0].label : selected[0];
        } else {
          this.position = isArray ? selected[1].label : selected[1];
        }
        // // 获取所属商圈
        if (isArray) {
          this.$refs.addLeaderEdit.form.setFieldsValue({
            bizAreaId: undefined
          });

          if (!val[2]) {
            this.formLeaderList[4].options = [];
            return;
          }

          this.$get({
            url: '/local/leader/bizTreeSelect',
            params: {
              regionId: val[2]
            }
          }).then(({data}) => {
            if (data.length > 0) {
              this.formLeaderList[4].options = data;
            } else {
              this.formLeaderList[4].options = [];
            }
            // this.formLeaderList[7].isShow = true;
            // this.formLeaderList[7].options = data;
          });
        }
      } else {
        // this.formLeaderList[7].isShow = false;
        // this.formLeaderList[7].options = [];
      }
    },
    getTypeDesc (type) {
      for (let i = 0; i < this.searchList[1].options.length; i++) {
        if (this.searchList[1].options[i].value === type + '') {
          return this.searchList[1].options[i].label;
        }
      }
      return '';
    },
    editHandle (row) {
      this.modalTitle = '编辑商户';
      this.modalLeaderTitle = '编辑';
      if (row.type !== 3) {
        this.$get({
          url: `/local/leader/info/${row.leaderId}`,
          params: {
            type: row.type
          }
        }).then(({data}) => {
          this.lngLat = [data.mapLng, data.mapLat];
          this.dataTypeChange(row.type + '');
          this.visible = true;
          let mobileRules = this.formList[1].props[1].rules;
          mobileRules.splice(1, 1);
          this.$nextTick(() => {
            this.$refs.addEdit.form.setFieldsValue({
              type: data.type + '',
              mobilePhone: data.mobilePhone,
              depositBank: data.depositBank,
              cardNumber: data.cardNumber,
              accountName: data.accountName
            });
            this.$refs.addEdit.routeQuery = row.leaderId;
            this.formList.forEach((el) => {
              el.disabled = true;
            });
          });
        });
      } else {
        this.$get({
          url: `/local/leader/info/${row.leaderId}`,
          params: {
            type: row.type
          }
        }).then(({data}) => {
          this.lngLat = [data.mapLng, data.mapLat];
          let regions = data.areas.split(',');
          this.newAreas = regions.toString();
          regions.forEach((i, index) => {
            if (i == 0) {
              regions.splice(index, 1);
            }
          });
          this.areaIndex = 1;
          this.regionSelectByIds(3, regions, 4);

          if (!regions[2]) {
            this.formLeaderList[4].options = [];
          } else {
            this.$get({
              url: '/local/leader/bizTreeSelect',
              params: {
                regionId: regions[2]
              }
            }).then(({data}) => {
              if (data.length > 0) {
                this.formLeaderList[4].options = data;
              } else {
                this.formLeaderList[4].options = [];
              }
            });
          }

          // let bizData = [];
          // let bizShow = false;
          // if (data.areas) {
          //   this.$get({
          //     url: '/local/leader/bizTreeSelect',
          //     params: {
          //       regionId: regions[2]
          //     }
          //   }).then(({data}) => {
          //     bizData = data;
          //     bizShow = true;
          //   });
          // }

          this.leaderVisible = true;
          let imgStr = '';
          if (data.shopImages) {
            this.formLeaderList[7].fileList = data.shopImages;
            data.shopImages.forEach(img => {
              imgStr += img.uid;
            });
          }
          // if (bizShow === true) {
          //   this.formLeaderList[7].isShow = true;
          //   this.formLeaderList[7].options = bizData;
          // }

          let mobileRules = this.formLeaderList[0].props[1].rules;
          mobileRules.splice(1, 1);
          this.$nextTick(() => {
            this.$refs.addLeaderEdit.form.setFieldsValue({
              type: data.type + '',
              mobilePhone: data.mobilePhone,
              shopName: data.shopName,
              shopImage: imgStr,
              categories: data.categories.split(','),
              areas: regions,
              bizAreaId: data.bizAreaId || undefined,
              address: data.address,
              telephone: data.telephone,
              mapLng: data.mapLng,
              mapLat: data.mapLat,
              depositBank: data.depositBank,
              cardNumber: data.cardNumber,
              accountName: data.accountName
            });
            this.$refs.addLeaderEdit.routeQuery = row.leaderId;
          });
          this.formLeaderList[0].disabled = true;
        });
      }
    },
    regionSelectByIds (index, areas, levelLimit = 4) {
      // if (this.areaIndex > 1) {
      //   return;
      // }
      if (this.areaIndex < areas.length) {
        let oldOptions = this.formLeaderList[index].options;
        let i = this.areaIndex - 1;
        if (areas[i] == 0) {
          return;
        }
        this.findOptionsId(oldOptions, areas[i]);
        let url = 'regions/list';
        this[handleHttpMethod('get', this)]({
          url: url,
          params: {
            // type: this.areaIndex + 1, // 获取省市区第几层级的返回数据
            parentId: areas[i]
          }
        }).then(({data}) => {
          this.areaIndex = this.areaIndex + 1;
          data && data.forEach(item => {
            if (item.level >= levelLimit || item.hasNext == 0) {
              item.isLeaf = true;
            } else {
              item.isLeaf = false;
            }
          });
          data.length > 0 && (this.singleOption.children = data);
          let region = this.formLeaderList[index];
          region.options = [...region.options];
          this.regionSelectByIds(index, areas, levelLimit);
        });
      }
    },
    editReqHandle () {

    },
    // 添加编辑返回处理
    addEditResHandle (msg) {
      this.$message.success(`${msg}成功`);
      this.visible = false;
      this.leaderVisible = false;
      this.$refs.table.getTableList();
    },
    resHandle (res) {
      this.visible = false;
      this.$refs.table.getTableList();
    },
    searchHandle (selectData) {
    },
    reqHandle (param) {
      if (param.areas) {
        param.areas = this.newAreas;
        // param.areas = param.areas.join(',');
      }
      if (param.shopImage) {
        param.shopImage = param.shopImage.join(',');
      }
      if (param.categories) {
        param.categories = param.categories.join(',');
      }
      if (!param.type) {
        param.type = 3;
      }
      return param;
    },
    addLeader () {
      this.$refs.addLeaderEdit.handleSubmit();
    }
  }
};
</script>
